import Icon from '../components/Icon';
import Input from '../components/Input';
import type { LinkElement } from '../types/news';

type Props = {
  element: LinkElement;
  onUpdate: (id: string, updates: Partial<LinkElement>) => void;
  onDelete: (id: string) => void;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  isFirst?: boolean;
  isLast?: boolean;
};

export default function LinkSection({
  element,
  onUpdate,
  onDelete,
  onMoveDown,
  onMoveUp,
  isFirst,
  isLast,
}: Props) {
  return (
    <div className="border border-gray-tint-6 rounded-_20 padding-3 w-full margin-top-2">
      <div className="flex justify-between items-center margin-bottom-2">
        <h3>Link</h3>
        <div className="flex gap-1 items-center">
          <Icon
            name="icon-arrow-up"
            size={1}
            className={
              isFirst ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'
            }
            onClick={!isFirst ? onMoveUp : undefined}
          />
          <Icon
            name="icon-arrow-down"
            size={1}
            className={
              isLast ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'
            }
            onClick={!isLast ? onMoveDown : undefined}
          />
          <Icon
            name="icon-bin"
            onClick={() => onDelete(element.id)}
            size={1}
            className="cursor-pointer"
          />
        </div>
      </div>

      <div className="flex flex-col gap-1 margin-bottom-2">
        <label>Beschrieb für Leser*innen</label>
        <Input
          type="textarea"
          value={element.linkDescription}
          onChange={(value) =>
            onUpdate(element.id, { linkDescription: value ?? '' })
          }
          placeholder="Kurzer Beschrieb für Leser*innen, der oberhalb des Links angezeigt wird"
        />
      </div>

      <div className="flex flex-col gap-1 margin-bottom-2">
        <label>URL einfügen</label>
        <Input
          type="text"
          value={element.url}
          maxlength={500}
          onChange={(value) => onUpdate(element.id, { url: value ?? '' })}
          placeholder="Hier URL eingeben"
        />
      </div>

      <div className="flex flex-col gap-1">
        <label>Anzuzeigender Text für URL</label>
        <Input
          type="text"
          value={element.showedText}
          maxlength={120}
          onChange={(value) =>
            onUpdate(element.id, { showedText: value ?? '' })
          }
          placeholder="Text anstelle der URL eingeben"
        />
      </div>
    </div>
  );
}
